<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" :summed="false" @load="loadSummary">
				<template #search>
					<m-search ref="search" :extend-data="defaultSearchData">
						<!-- 平台积分账户余额汇总 -->
						<div class="stats-bar flex">
							<div class="stats-card card-orange">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">同售积分</span>
										<span class="stats-value">{{formatPoints(balance.channel_points)}}</span>
									</div>
								</div>
								<div class="stats-icon">分</div>
							</div>
<!--							<div class="stats-card card-green">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">IMIE积分</span>
										<span class="stats-value">{{formatPoints(balance.imie_points)}}</span>
									</div>
								</div>
								<div class="stats-icon">分</div>
							</div>-->
						</div>
                        <m-search-item label="商户信息" colspan="2">
                            <c-select name="saas_ids" multiple async @search="searchSaas"></c-select>
                        </m-search-item>
						<m-search-item label="记录单号">
							<c-input name="record_number"></c-input>
						</m-search-item>
						<m-search-item label="业务单号">
							<c-input name="docket_number"></c-input>
						</m-search-item>
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="收支类型">
                            <c-select :options="INCOME_EXPENSES" name="income_expenses"></c-select>
                        </m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_platform_points_account_export')"
							  prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
				</template>

				<!--账户类型-->
				<template #account_type="{data}">
					<c-state tag async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
				</template>
				<!--收支类型-->
				<template #income_expenses="{data}">
					<c-state tag async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
				</template>
				<!--收支状态-->
				<template #trans_state="{data}">
					<c-state tag async dict="TRANS_STATE" :value="data.trans_state"></c-state>
				</template>
				<!--变动积分（积分数值由后端实体getMoney转换，无需分转元）-->
                <template #money="{data}">
                    <span v-if="data.income_expenses == 1" style="color: green">+{{data.money}}</span>
                    <span v-if="data.income_expenses == 2" style="color: red">{{data.money}}</span>
                </template>
				<!--积分余额（积分数值由后端实体getSurplus_money转换，无需分转元）-->
				<template #surplus_money="{data}">
					{{data.surplus_money}}
				</template>

				<!--汇总统计：后端按当前筛选口径对全量数据聚合（收入累加、支出扣减），与分页无关-->
				<template #foot>
					<div class="summary-bar flex-start-center">
						<span class="summary-item">收入合计<span class="summary-value income">{{ incomeText }}</span></span>
						<span class="summary-item">支出合计<span class="summary-value expense">{{ expenseText }}</span></span>
						<span class="summary-item">净额<span class="summary-value" :class="netClass">{{ netText }}</span></span>
					</div>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
	name: 'p_platform_points_account',

	data() {
		return {
			workType: 126,
			//平台积分账户余额汇总（同售积分 / IMIE积分）
			balance: {
				channel_points: 0,
				imie_points: 0
			},
			//积分收支汇总（当前筛选口径全局统计，与分页无关）
			summary: {},
			defaultSearchData: {
				trans_states: [1, 3]  //不展示【2：处理中】的记录
			}
		}
	},

	computed: {
		...mapState(['saasInfo']),
        ...asyncMapState(['INCOME_EXPENSES']),
		incomeText() {
			return this.formatPoints(this.summary.income_money);
		},
		expenseText() {
			return this.formatPoints(this.summary.expense_money);
		},
		netText() {
			const val = parseFloat(this.summary.net_money);
			if (isNaN(val)) return '0';
			return (val > 0 ? '+' : '') + val.toLocaleString();
		},
		netClass() {
			const val = parseFloat(this.summary.net_money);
			return isNaN(val) || val == 0 ? '' : (val > 0 ? 'income' : 'expense');
		}
    },

	mounted() {
		this.loadBalance();
	},

	methods: {
        /*******搜索商户*****************/
        searchSaas(keyword, resolve){
            this.request({
                url: '/sys_saas/options',
                data: {
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
		/**
		 * 加载平台积分账户余额汇总（顶部资金汇总卡片）
		 */
		loadBalance() {
			this.request({
				url: '/financial/platform/account/balance',
				data: {},
				success: data => {
					this.balance = {
						channel_points: data && data.channel_points ? data.channel_points : 0,
						imie_points: data && data.imie_points ? data.imie_points : 0
					};
				}
			});
		},

		/**
		 * 累计积分变化统计（与列表同筛选口径，随搜索/视图/分页联动刷新）
		 */
		loadSummary(listData, searchParams) {
			this.request({
				url: '/financial/platform/points/account/summary',
				data: Object.assign({}, searchParams),
				success: data => {
					this.summary = data || {};
				}
			});
		},

		/**
		 * 积分格式化（积分无单位换算，直接展示数值）
		 */
		formatPoints(val) {
			if (val === undefined || val === null || val === '') {
				return '0';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0' : num.toLocaleString();
		}
	}
}
</script>

<style lang="stylus" scoped>
	.summary-bar {
		flex-shrink: 0;
		gap: 32px;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;
		font-size: 13px;
		color: #666;

		.summary-item {
			display: inline-flex;
			align-items: baseline;

			.summary-value {
				margin-left: 6px;
				font-size: 16px;
				font-weight: bold;

				&.income {
					color: #67C23A;
				}

				&.expense {
					color: #F56C6C;
				}
			}
		}
	}

	.stats-bar {
		flex-wrap: wrap;
		gap: 10px;
		width: 100%;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;

		.stats-card {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 260px;
			max-width: 550px;
			min-height: 56px;
			padding: 8px 16px;
			border-radius: 6px;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;

			&.card-orange {
				background: linear-gradient(90deg, #f97316, #fb923c);
			}

			&.card-green {
				background: linear-gradient(90deg, #16a34a, #22c55e);
			}

			.stats-info {
				position: relative;
				z-index: 1;

				.stats-title-row {
					display: flex;
					align-items: baseline;
					line-height: 24px;

					.stats-label {
						font-size: 12px;
						opacity: 0.95;
					}

					.stats-value {
						margin-left: 6px;
						font-size: 18px;
						font-weight: bold;
					}
				}

				.stats-summary-row {
					gap: .5em;
					margin-top: 2px;
					font-size: 11px;

					label {
						opacity: 0.9;
					}
				}
			}

			.stats-icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 32px;
				line-height: 1;
				opacity: 0.15;
			}
		}
	}
</style>